import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { KYMW1707Model } from './kymw1707.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetRemindMailTempService } from './api-services/get-remind-mail-temp.service';
import { SendRemindMailInfoService } from './api-services/send-remind-mail-info.service';
import { RemindMailTempModel } from './vo/remind-mail-temp-model';

/**
 * 差し戻し理由入力画面を管理するクラス
 *
 * @export KYMW1707Component
 * @class KYMW1707Component
 */
@Component({
  selector: 'app-kymw1707',
  templateUrl: 'kymw1707.component.html',
  styleUrls: ['kymw1707.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1707Component extends PlessViewHelperSub implements OnInit {
  public kymw1707Model: KYMW1707Model = new KYMW1707Model();
  public closeFunction: Function;

  /**
   * Creates an instance of KYMW1707Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetRemindMailTempService} getRemindMailTempService
   * @param {SendRemindMailInfoService} sendRemindMailInfoService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1707Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public getRemindMailTempService: GetRemindMailTempService,
    public sendRemindMailInfoService: SendRemindMailInfoService,
    private kymw00Model: KYMW00Model
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   * @memberof KYMW1707Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1707';
    // 催促メール定型文取得処理
    this.getRemindMailTempService.execute((remindMailTempList: RemindMailTempModel[]) => {
      this.kymw1707Model.remindMailTempList = remindMailTempList;
    });
  }

  /**
   * 親画面から値を設定する
   * @param supplierName          サンプル発注先名称
   * @param supplierAnnouncement  取引先への連絡事項
   * @param imageFileName         画像ファイル名
   */
  public setParameter(supplierName: string, supplierAnnouncement: string, imageFileName: string): void {
    this.kymw1707Model.supplierName = supplierName;
    this.kymw1707Model.supplierAnnouncement = supplierAnnouncement;
    this.kymw1707Model.imageFileName = imageFileName;
  }

  /**
   * 催促メールテンプレートの変更
   */
  public eventChangeHandler_SelectRemindTemplate(event: any) {
    if (event === null) {
      return;
    }
    // プレビュー画面に反映する
    this.kymw1707Model.remindMailTempId = event.target.value;
    this.kymw1707Model.remindMailTempList
      .filter(_ => _.RemindMailTempId === this.kymw1707Model.remindMailTempId)
      .forEach(_ => {
        this.kymw1707Model.title = _.Title;
        this.kymw1707Model.mainText = _.MainText;
      });
  }

  /**
   * 定型文を選択しているかどうか
   * @returns 
   */
  public isSelected(): boolean {
    return !PlessViewUtilsSub.isEmpty(this.kymw1707Model.remindMailTempId)
  }

  /**
   * 催促
   * @memberof KYMW1707Component
   */
  public eventClickHandler_Remind(): void {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1707Model.imageFileName)) {
      this.dialogService.openAlertGetMessage('W0001', ['画像ファイル名']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1707Model.remindMailTempId)) {
      this.dialogService.openAlertGetMessage('W0001', ['定型文の選択']);
      return;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw1707Model.supplierAnnouncement)) {
      this.dialogService.openAlertGetMessage('W0001', ['取引先への連絡事項']);
      return;
    }
    // 催促メール情報送信
    this.sendRemindMailInfoService.execute(this.kymw1707Model.imageFileName, this.kymw1707Model.remindMailTempId, this.kymw1707Model.supplierAnnouncement, () => {
      this.eventClickHandler_Close();
    });
  }

  /**
   * 画面を閉じる
   * @memberof KYMW1707Component
   */
  public eventClickHandler_Close(): void {
    this.onClickClose()
  }
}
